import Vue from "vue";
import Router from "vue-router";
import store from "../store";

import { routes } from "./routes";

import { CheckToken } from "@/api/login";
import { GetSystemConfig } from "@/api/config";
import { baseUrl } from "../config/env";
import { saveAuthRedirectPath, buildLoginRedirectQuery } from "../utils/util";
import {
  ANNOUNCEMENT_MODULE,
  getModuleByRouteName,
} from "../utils/announcementPopup";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
Vue.use(Router);


const router = new Router({
  routes,
});

router.beforeEach(async (to, from, next) => {
  // code为修改密码策略后发送邮件跳转后的

  const routeName = to.name;
  const clientToken = localStorage.clientToken || store.state.clientToken;
  const queryToken = to.query.token;

  const noCheckTokenRoute = [
    "retrievePassword",
    "changePassword",
    "forgetPassword",
    "EntranceFromEmail",
    "CheckLicense",
    "test"];

  const isAuthProtectedRoute =
    routeName &&
    !noCheckTokenRoute.includes(routeName) &&
    routeName !== "login" &&
    routeName !== "401" &&
    routeName !== "maintenance";
  if (isAuthProtectedRoute && to.fullPath) {
    saveAuthRedirectPath(to.fullPath);
  }

  const { disableSSO } = to.query;

  let uiConfig = store.state.uiConfig;
  let systemConfig = store.state.systemConfig;

  if (!Object.keys(systemConfig).length || !uiConfig || !uiConfig.id) {
    await store.dispatch("GetCurrentSystemConfig");
    uiConfig = store.state.uiConfig;
  }

  const { isSystemMaintain } = store.state.systemConfig

  const isCheckQueryToken = () => {
    const { isssoout, returnUrl, defaultUrl, redirect } = to.query;

    if (isssoout) {
      localStorage.clientisssoout = isssoout;
    } else {
      localStorage.removeItem("clientisssoout");
    }

    /* eslint-disable */
    if (!!returnUrl) {
      localStorage.clientReturnUrl = returnUrl;
    } else {
      localStorage.removeItem("clientReturnUrl");
    }
    if (defaultUrl) {
      sessionStorage.clientDefaultUrl = defaultUrl;
    } else {
      localStorage.removeItem("clientDefaultUrl");
    }
    if (defaultUrl) {
      next({
        name: "CheckLicense",
        query: { redirect: defaultUrl },
      });
    } else if (redirect) {
      next({
        name: "CheckLicense",
        query: { redirect: redirect },
      });
    } else {
      const goWhiteList = [
        "login",
        "CheckLicense",
        "retrievePassword",
        "forgetPassword",
        "changePassword",
        "EntranceFromEmail",
      ];
      if (!goWhiteList.includes(routeName)) {
        next({ name: "CheckLicense", query: { path: to.path } });
      } else {
        next({ name: "CheckLicense" });
      }
    }
  };
  const loginCheck = (paramsToken) => {
    CheckToken({
      token: paramsToken || clientToken,
    })
      .then((res) => {
        if (res && res.data.isSuccess && res.data.tokenAccess) {
          let token = res.data.tokenAccess;

          store.commit("setToken", token);

          isCheckQueryToken();
        }
      })
  };

  const goToLogin = () => {
    const isToken = !!localStorage.clientToken;
    if (isToken) {
      loginCheck();
    } else {
      if (!disableSSO) {
        localStorage.removeItem("disableSSO");
      }

      if (disableSSO || localStorage.disableSSO) {
        localStorage.disableSSO = true;
      }

      const loginQuery = {
        ...to.query,
        ...buildLoginRedirectQuery(to.fullPath),
      };

      GetSystemConfig().then((res) => {
        let goToUrl = "";

        if (res && res.data) {
          const {
            autoRedirect,
            isPassiveSso,
            ssoLoginUri,
            isActiveSso,
          } = res.data;

          if (!autoRedirect) {
            const ssoredirect = encodeURIComponent(window.location.href); //用来做sso单点登录的带参跳转，把当前url传给单点登录接口，由接口确定是不是要跳转
            /**如果不是自动登陆就判断是否返回登陆的地址*/
            if (isPassiveSso && !localStorage.disableSSO && isActiveSso) {
              /** 固定跳转 */
              goToUrl = baseUrl + "/portalbasicapi/sso/LoginSsoUri?ssoredirect=" + ssoredirect;
            } else if (
              isPassiveSso &&
              !localStorage.disableSSO &&
              ssoLoginUri &&
              ssoLoginUri !== "" &&
              !isToken
            ) {
              /**配置URL的跳转 */
              if (ssoLoginUri.includes("?")) {
                goToUrl = ssoLoginUri + "&ssoredirect=" + ssoredirect;
              } else {
                goToUrl = ssoLoginUri + "?ssoredirect=" + ssoredirect;
              }
            }
          }
        }
        if (goToUrl) {
          location = goToUrl;
        } else {
          next({ query: loginQuery });
        }
      });
    }
  };

  const defaultNext = async () => {
    const isToken = !!localStorage.clientToken;
    const { systemConfig, clientGlobalRole } = store.state;

    if (!isToken) {
      /**如果没有token就直接跳到登陆 */

      if (to.name.includes("find")) {
        next({
          name: "login",
        });
      } else {
        next({
          name: "login",
          query: buildLoginRedirectQuery(to.fullPath),
        });
      }
    }
    else if (
      systemConfig.angleOfView &&
      systemConfig.angleOfView == 2 &&
      from.name !== "CheckLicense" &&
      routeName !== "CheckLicense" &&
      (!clientGlobalRole || !localStorage.clientGlobalRole)
    ) {
      // 如果切换视角模式后没有角色就跳到角色

      next({ name: "CheckLicense" });
    }
    else {


      // 如果本地有配置某些菜单不显示，就拦截路由跳转到404或者指定地址
      // meta: {controlField: 'myMenu'},

      const currentRouteIsAuth = to.meta && to.meta.controlField;

      // const clientUIConfig = store.state.systemConfig.clientUIConfig;
      // const reportWhiteList = ["report", "reportList", "reportView"];
      const findWhiteList = ["find", "findList", "findView"];

      let is404 = false;

      /**如果没有portal权限，就不能进发现页和自定义首页 */
      /**如果是海康的环境，到发现页就主动跳到报表页 */
      let isGotoReport = false;

      isGotoReport = findWhiteList.includes(routeName) && !store.state.isShowPortal;
      if (routeName == "customHome" && !store.state.isShowPortal) {
        isGotoReport = true;
      }

      const { isPortal } = store.state;

      if (isGotoReport && isPortal) {
        next({ name: "report" });
        return;
      }

      let isShowDesign =
        !store.state.isShowDesign && to.path.includes("/design/");

      if (isShowDesign) {
        next({ name: "home" });
        return;
      }

      // TODO:之前在系统配置配置的开关代码先注释掉，后期删除
      // if (clientUIConfig) {
      //   /**如果配置了隐藏报表和发现、我的 这些菜单就不能进这些页面 */
      //   is404 =
      //     (clientUIConfig.report && reportWhiteList.includes(routeName)) ||
      //     (clientUIConfig.find && findWhiteList.includes(routeName)) ||
      //     (clientUIConfig.my && to.path.includes("/about/")) ||
      //     (clientUIConfig.design && to.path.includes("/design/"));
      // }

      /** @
       * 1. 判断有没有对这个做UI配置的操作
       * 2. 然后分析上边的权限判断
       * 3. 首次登陆不能进404
       * 4. 首次登陆进404之前需要循环一下看哪个菜单有权限
       * 5. 菜单权限要加上用户权限才能进行跳转操作
       */

      if (currentRouteIsAuth && uiConfig[currentRouteIsAuth] == "off") {

        let nextMenuName = "";

        const homeMenu = routes.find((item) => item.name == "home");

        if (homeMenu) {
          const children = homeMenu.children || [];

          const filterGoto = children.find(
            (item) =>
              item.meta &&
              !item.meta.noAuth &&
              item.meta.controlField &&
              uiConfig[item.meta.controlField] !== "off"
          );

          if (filterGoto) {
            nextMenuName = filterGoto.name;
          }
        }
        if (nextMenuName) {
          next({ name: nextMenuName });
          return;
        } else {
          is404 = true;
        }
      }

      if (is404) {
        return;
      } else {
        next();
      }
    }
  };
  if (isSystemMaintain) {
    routeName !== 'maintenance' ? next({ name: 'maintenance' }) : next()
  } else if (!isSystemMaintain && routeName == 'maintenance') {
    next({ path: "/" })
  } else {

    if (noCheckTokenRoute.includes(routeName)) {
      next()
      return
    }
    if (queryToken) {
      localStorage.removeItem("disableSSO");
      loginCheck(queryToken);
      return;
    }
    if (store.state.LicenseStatus && routeName !== "CheckLicense") {
      // 授权失败并且没有token的时候 清除本地记录跳到登录
      store.commit("logout");
      return;
    }
    if (routeName == "login") {
      goToLogin();
      return;
    }
    if (!routeName) {
      /**如果没定义路由的name，跳到404页面 */
      // next({ name: "404" });
      return;
    }

    const isToken = !!localStorage.clientToken;

    if (isToken && !store.state.user.id) {
      try {
        await store.dispatch("getCurrentUser");
        defaultNext();
      } catch (e) {
        saveAuthRedirectPath(to.fullPath);
        store.commit("clearAuthSession");
        next({
          name: "login",
          query: buildLoginRedirectQuery(to.fullPath),
        });
      }
      return;
    } else {
      defaultNext();
    }


  }







});

router.afterEach((to) => {
  const module = getModuleByRouteName(to.name);
  if (
    module != null &&
    module !== ANNOUNCEMENT_MODULE.Global &&
    router.app
  ) {
    router.app.$root.$emit("open-module-announcement", module);
  }
});

export default router;
